import React from "react";
import PageTitle from "../../components/PageTitle";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import BtnGenerateRRR from "../../buttons/BtnGenerateRRR";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import moment from "../../helpers/moment";
import is_money from "../../helpers/is_money";
import VerifyPayment from "./VerifyPayment";
import PrintReceipt from "./PrintReceipt";

const PayFee = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["generatedRRR"],
    queryFn: async () => {
      const req = await axiosget("ms_application_fee");
      return req?.data;
    },
  });
  return (
    <>
      <PageTitle title={`Application Fees`} sub={`Manage application fee payments, payment history, verify payments, and print receipts`} />
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.type !== undefined && <ErrorResponse type={`danger`} message={`${data?.message}`} />}
      <div className="row">
        {data &&
          data?.type === undefined &&
          data?.map((v, i) => (
            <div className="col-md-6 my-4" key={`_payments_for_applications_${i}`}>
              <div className="card border border-success">
                <div className="card-body">
                  <p className="card-text">
                    <b>Remita RRR:</b> {v?.trxcode}
                  </p>
                  <p className="card-text">
                    <b>Amount: </b>
                    {is_money(v?.amount)}
                  </p>
                  <p className="card-text">
                    <b>Description:</b> {v?.trxdata?.description}
                  </p>
                  <p className="card-text">
                    <b>Is Used For Application:</b> {v?.application ? `Has been used for ${v?.application}` : "Not used"}
                  </p>
                  <p className="card-text">
                    <b>Is Payment Verified: </b>
                    {v?.isverified ? `Verified` : "Not Verified"}
                  </p>
                  <p className="card-text">
                    <b>Generated:</b> {moment(v.createdAt)} ago
                  </p>
                </div>
                <div className="card-footer text-body-secondary">{v.verified ? <PrintReceipt v={v} /> : <VerifyPayment v={v} />}</div>
              </div>
            </div>
          ))}
      </div>
      <BtnGenerateRRR />
    </>
  );
};

export default PayFee;
